
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">اضافة مشروع</h5>

                       <span> بالرجاء ملئ جميع الحقول </span>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form [formGroup]="insertForm" (ngSubmit)="Submit()">

                    <div class="row m-0 mb-2">
                        <div class="col-md-6">
                          <label for=""> اسم المشروع
                          </label>
                            <div class="form-group">
                                
                               <input type="text"  class="form-control"  formControlName="titleAr" 
                               [tooltip]="fc.titleAr.errors?.required ? ' الاسم مطلوب' : null" required
                               [isDisabled]="!((fc.titleAr.errors?.required && fc.title.touched))"
                               containerClass="" [class.is-valid]="fc.titleAr.valid && (fc.title.touched)"
                               [class.is-invalid]="fc.titleAr.invalid && (fc.titleAr.touched)"
                               >
                            </div>
                        </div>
                        <!-- <div class="col-md-4">
                          <label for=""> اسم المشروع باللغة الانجليزية
                          </label>
                            <div class="form-group">
                                
                               <input type="text"  class="form-control" appDisableWeritingArabic formControlName="title" 
                               [tooltip]="fc.title.errors?.required ? ' الاسم مطلوب' : null" required
                               [isDisabled]="!((fc.title.errors?.required && fc.title.touched))"
                               containerClass="" [class.is-valid]="fc.title.valid && (fc.title.touched)"
                               [class.is-invalid]="fc.title.invalid && (fc.title.touched)"
                               >
                            </div>
                        </div> -->
                        <div class="col-md-6">
                          <label for=""> رابط الفيديو
                          </label>
                            <div class="form-group">
                               <input type="text"  class="form-control" formControlName="videoLink" 
                               >
                            </div>
                        </div>
                        <div class="col-md-12">
                            <label for=""> الوصف
                            </label>
                              <div class="form-group">
                                  
                                 <textarea type="text"  style="height: 100px;"  class="form-control" formControlName="descriptionAr" 
                                 [tooltip]="fc.descriptionAr.errors?.required ? ' الوصف مطلوب' : null" required
                                 [isDisabled]="!((fc.descriptionAr.errors?.required && fc.descriptionAr.touched))"
                                 containerClass="" [class.is-valid]="fc.descriptionAr.valid && (fc.descriptionAr.touched)"
                                 [class.is-invalid]="fc.descriptionAr.invalid && (fc.descriptionAr.touched)"
                                 ></textarea>
                              </div>
                          </div>
                          <!-- <div class="col-md-6">
                            <label for="">   الوصف باللغه الانجليزية
                            </label>
                              <div class="form-group">
                                  
                                 <textarea type="text"  style="height: 100px;" appDisableWeritingArabic class="form-control" formControlName="description" 
                                 [tooltip]="fc.description.errors?.required ? ' الوصف مطلوب' : null" required
                                 [isDisabled]="!((fc.description.errors?.required && fc.description.touched))"
                                 containerClass="" [class.is-valid]="fc.description.valid && (fc.description.touched)"
                                 [class.is-invalid]="fc.description.invalid && (fc.description.touched)"
                                 ></textarea>
                              </div>
                          </div> -->
                          <div class="col-md-6">
                            <label for=""> رابط صفحة الفيس بوك
                              ( السوشيال ميديا )
                            </label>
                              <div class="form-group">
                                  
                                 <input type="text"  class="form-control" formControlName="facebookLink" 
                                 >
                              </div>
                          </div>
                          <div class="col-md-6">
                            <label for=""> رابط صفحة الانستجرام
                              ( السوشيال ميديا )
                            </label>
                              <div class="form-group">
                                  
                                 <input type="text"  class="form-control" formControlName="instagramLink" >
                              </div>
                          </div>
                          <div class="col-md-6">
                            <label for=""> رابط قناة اليوتيوب
                              ( السوشيال ميديا )
                            </label>
                              <div class="form-group">
                                  
                                 <input type="text"  class="form-control" formControlName="youtubeLink" 
                                 >
                              </div>
                          </div>
                          <div class="col-md-6">
                            <label for="">   رابط صفحة التيك توك
                              ( السوشيال ميديا ) 
                            </label>
                              <div class="form-group">
                                  
                                 <input type="text"  class="form-control" formControlName="tiktokLink" 
                                 >
                              </div>
                          </div>
                          <div class="col-lg-6 col-sm-12  mb-3" style="margin-top: 7px;">
                            <label for="validationCustom06"> كلمات دليلية</label>
                            <ng-multiselect-dropdown
                                   formControlName="keywords"
                                   [placeholder]="'اختر كلمة  '"
                                   [settings]="dropdownSettings"
                                   [data]="keyword"
                                   [(ngModel)]="selectedItems">
                                             </ng-multiselect-dropdown>
                        </div>
                                  
                         <!-- to insert image  -->
                         <div class="col-6 my-3 " >
                          <img  src="{{ imageLogo }}" style="width: 60%; height: 220px;" class="image-style p-2" />
                         <input type="file" formControlName="branchImage" accept="image/*" #file id="getLogo"
                          style="display: none" (change)="getLogoUrl($event)" />
                      <button type="button" onclick="document.getElementById('getLogo').click()"
                          class="btn   d-block"  style="width: 60%;">
                          ارفاق صورة
                      </button>    
                                  </div>
                     
                        <div class="col-12 col-md-12">
                            <div *ngIf="update; else elseBlock">
                                <button [disabled]="DisableBtn" class="btn  pull-right" type="submit" >
                                  تعديل
                                </button>
                              </div>
                  
                              <ng-template #elseBlock>
                                <button [disabled]="DisableBtn" class="btn  pull-right" type="submit">
                                  إضافة
                                </button>
                              </ng-template>
                </div>
                </div>
                    </form>
    </div>
</div>
        </div>
    </div>
</div>